import { Component, OnInit } from "@angular/core";
import { LeftMenuItem } from '../../../_models/_index';

@Component({
    selector: 'left-menu',
    templateUrl: 'left-menu.component.html',//+ appVersion,
    moduleId: module.id
})

export class LeftMenuComponent implements OnInit {
    listButtons: LeftMenuItem[];
    selectedItem: LeftMenuItem;
    
    constructor() {
    }
    ngOnInit() {
        this.listButtons = [
            {
                "routerLink": "/home/deal-wizard/0/''/false",
                "name": "הקמת חוזה",
                "image": "handshake-64.png"
                
            },
            {
                "routerLink": "deals",
                "name": "חוזים",
                "image": "business-64.png"
                
            },
            {
                "routerLink": "terms-of-use",
                "name": "תנאי שימוש",
                "image": "interface-64.png"
             
            },
            {
                "routerLink": "parameters",
                "name": "פרמטרים",
                "image": "technology-64.png"
                
            },
            {
                "routerLink": "service-items",
                "name": "פרטי שירות",
                "image": "folder-64.png"
                
            },
            {
                "routerLink": "terms",
                "name": "תנאים",
                "image": "interface-64.png"
                
            },
            {
                "routerLink": "users",
                "name": "משתמשים",
                "image": "people-64.png"
                
            }
        ];
     
        this.selectedItem = this.listButtons[1];
    }
    selectButton(button: LeftMenuItem) {
        this.selectedItem = button;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/home-page/left-menu/left-menu.component.ts